var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGardenDashboardNotificationSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GardenDashboardNotificationSVG 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bullhorn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "horn",
    d: "M11.5806 73.6957C11.5806 73.6957 7.71336 72.834 5.81008 75.408C3.55811 78.4533 5.48264 83.6195 10.2603 88.7766C14.3388 93.1791 19.7168 96.418 23.9969 94.8822C27.5658 93.6016 27.6875 87.393 27.6875 87.393C27.6875 87.393 71.7998 67.9545 86.8703 57.7969C86.8703 57.7969 91.5898 60.0449 93.9754 57.5467C97.9715 53.3617 94.7361 36.6125 78.5539 20.4867C65.1238 7.10303 48.624 1.45665 42.7113 4.64033C38.5869 6.86125 40.8945 12.7767 40.8945 12.7767C40.8945 12.7767 15.1266 64.8447 11.5806 73.6957Z",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hornHandle",
    d: "M47.7057 78.7572C47.7057 78.7572 49.5854 85.0889 52.3615 86.7229C57.5445 89.7734 69.8375 84.083 70.6246 78.7926C71.1816 75.0482 66.6863 69.3732 66.6863 69.3732",
    stroke: "#065D44",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGardenDashboardNotificationSvg);
export default __webpack_public_path__ + "static/media/GardenDashboardNotificationSVG.2cafad4f8aeaaf928408e7fa672ce462.svg";
export { ForwardRef as ReactComponent };